const maxSeconds = 60
const maxMinutes = 60
const maxHours = 24

export const currentDate = () => (new Date()).toISOString().split('T')[0]

/**
 *
 * @param date {Date | string | number}
 * @param number {days}
 * @returns {string}
 */
export const subDays = (date, days) => (new Date(
	new Date(date) - 1000 * maxSeconds * maxMinutes * maxHours * days
)).toISOString().split('T')[0]
